// Generated file : do not modify
export enum EtablissementPoleEmploiStatuts
{
  NONE = 0,
  NO_LICENCE,
  STATUS_REQUIRED_OLD,
  VERIFYING_USER,
  VERIFYING_OLD,
  ASKED,
  VALID,
  INVALID,
  NOT_SHOW,
  WAIT_MONTH
};

export enum EtablissementModeFactures
{
  NONE = 0,
  REGLEMENT,
  GLOBAL,
  PROJET
};

import FractionDsn from '@/extend/classes/FractionDsn';
import { MetaValue } from '@/extend/classes/MetaAttrib';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Etablissements
export class ExoPeriode {
  // Période
  public periode: Date;
  // Exoneration apprentis
  public apprenti: boolean;

  constructor() {
    this.periode = new Date(1901,1,1,0,0,0,0);
    this.apprenti = false;
  }
}

export default class Etablissement  {
  // Identifiant unique
  public id: number;
  // Établissement DOM-TOM
  public isDomtom: boolean;
  // Société de rattachement
  public societeId: number;
  // Nom usuel
  public alias: string;
  // Nom
  public nom: string;
  // SIRET
  public siret: string;
  // Vérification demandée au serveur
  public verifySiret: boolean;
  // Siret établissement validé
  public siretValid: boolean;
  // Etablissement validé
  public valid: boolean | null;
  // Code APE
  public brancheId: number;
  // Code APE
  public brancheCode: string;
  // Activité APE
  public brancheNom: string;
  // Branche d'activité donnée par l'INSEE
  public brancheInsee: boolean;
  // Convention
  public conventionId: number;
  // Type d'activité
  public t3252: number;
  // Type de structure
  public t1790: number;
  // IDCC
  public conventionCode: string;
  // Convention collective
  public conventionNom: string;
  // Convention collective donnée par l'INSEE
  public conventionInsee: boolean;
  // Siège de la société
  public siege: boolean;
  // Effectif
  public trancheEffectifId: number;
  // Effectif
  public trancheEffectifLabel: string;
  // Assujetti à la TVA
  public soumisTva: boolean | null;
  // Forme juridique
  public formeJuridiqueId: number;
  // Forme juridique
  public formeJuridiqueLabel: string;
  // Forme juridique donné par l'INSEE
  public formeJuridiqueInsee: boolean;
  // Code RNE
  public identAssociation: string;
  // Date de création
  public dateCreation: Date;
  // Date de fermeture
  public dateFermeture: Date | null;
  // Etablissement géré
  public managed: boolean;
  // Représentant légal
  public representantId: number;
  // Représentant Legal
  public representantLegal: boolean;
  // Téléphone de l'établissement
  public numero: string;
  // Adresse mail de l'établissement
  public mail: string;
  // Adresse
  public adresseId: number;
  // Ville
  public ville: string;
  // Adresse Ligne 1
  public adresseLigne1: string;
  // Code Postal
  public codePostal: string;
  // Caisse URSSAF
  public urssafId: number;
  // Numéro URSSAF
  public urssaf: string;
  // Numéro Congés Spectacle
  public congesSpec: string;
  // Numéro AUDIENS
  public audiens: string;
  // Statut
  public poleEmploiStatut: EtablissementPoleEmploiStatuts;
  // cadre d'embauche
  public cadreEmbaucheId: number;
  // N° Affiliation France Travail
  public poleEmploiAffiliation: string;
  // N° de déclaration sociale France Travail
  public poleEmploiAdhesion: string;
  // N° d'identifiant Espace Employeur France Travail
  public poleEmploiIdentifiant: string;
  // N° d'affiliation FNAS
  public fnas: string;
  // N° d'affiliation FCAP
  public fcap: string;
  // Caisse de retraite complémentaire
  public retraiteComplementaireId: number;
  // Caisse de retraite complémentaire
  public retraiteComplementaireNom: string;
  // Statut de la licence
  public licenceStatus: number;
  // N° de récépissé licence
  public licenceRecepisse: string;
  // Licence d'entrepreneur de spectacles vivants
  public licenceSpectacle: string;
  // Date d'expiration de la licence
  public licenceValidite: Date | null;
  // Licence d’entrepreneur de spectacles vivants
  public statutLicenceSpectacle: string;
  // Id Ci98
  public IdCi98: number;
  // Fraction DSN
  public fractionDsn: FractionDsn[];
  // Périodes d'exonération'
  public exoPeriodes: ExoPeriode[];
  // Image
  public logo: string;
  // Abonnement
  public subscriptionId: number;
  // Prélèvements à la source
  public prelevRibId: number;
  // Compte prélèvements 
  public prelevRib: string;
  // Salaire et frais
  public salaireMeansId: number;
  // Compte Salaire et frais
  public salaireRib: string;
  // payment automatique
  public paymentAutoSalaire: boolean;
  // Paies à régler
  public hasCartItems: boolean;
  // Item dans la prochaine facture
  public hasBillItems: boolean;
  // Nombre accident travail
  public accidentTravailCount: number;
  // Nombre de documents
  public documentCount: number;
  // J'ai conclu un accord collectif pour la DFS
  public accordCollectif: boolean | null;
  // A des employés permanents
  public hasPermanents: boolean;
  // Abonnement suggéré
  public suggestedSubscriptionTypeId: number;
  // Commercial
  public commercialId: number;
  // Utilisateur
  public userId: number;
  // Compte désactivé
  public userDisabled: boolean;
  // Regroupement des factures
  public modeFacture: EtablissementModeFactures;
  // Encours maximum autorisé
  public creditLimit: number;
  // Autorisé jusqu'au
  public creditLimitUntil: Date | null;
  // Méta-attributs
  public metaValues: MetaValue[];
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.isDomtom = false;
    this.societeId = 0;
    this.alias = '';
    this.nom = '';
    this.siret = '';
    this.verifySiret = false;
    this.siretValid = false;
    this.valid = null;
    this.brancheId = 0;
    this.brancheCode = '';
    this.brancheNom = '';
    this.brancheInsee = false;
    this.conventionId = 0;
    this.t3252 = 0;
    this.t1790 = 0;
    this.conventionCode = '';
    this.conventionNom = '';
    this.conventionInsee = false;
    this.siege = false;
    this.trancheEffectifId = 0;
    this.trancheEffectifLabel = '';
    this.soumisTva = null;
    this.formeJuridiqueId = 0;
    this.formeJuridiqueLabel = '';
    this.formeJuridiqueInsee = false;
    this.identAssociation = '';
    this.dateCreation = new Date(1901,1,1,0,0,0,0);
    this.dateFermeture = null;
    this.managed = false;
    this.representantId = 0;
    this.representantLegal = false;
    this.numero = '';
    this.mail = '';
    this.adresseId = 0;
    this.ville = '';
    this.adresseLigne1 = '';
    this.codePostal = '';
    this.urssafId = 0;
    this.urssaf = '';
    this.congesSpec = '';
    this.audiens = '';
    this.poleEmploiStatut = EtablissementPoleEmploiStatuts.NONE;
    this.cadreEmbaucheId = 0;
    this.poleEmploiAffiliation = '';
    this.poleEmploiAdhesion = '';
    this.poleEmploiIdentifiant = '';
    this.fnas = '';
    this.fcap = '';
    this.retraiteComplementaireId = 0;
    this.retraiteComplementaireNom = '';
    this.licenceStatus = 0;
    this.licenceRecepisse = '';
    this.licenceSpectacle = '';
    this.licenceValidite = null;
    this.statutLicenceSpectacle = '';
    this.IdCi98 = 0;
    this.fractionDsn = [];
    this.exoPeriodes = [];
    this.logo = '';
    this.subscriptionId = 0;
    this.prelevRibId = 0;
    this.prelevRib = '';
    this.salaireMeansId = 0;
    this.salaireRib = '';
    this.paymentAutoSalaire = false;
    this.hasCartItems = false;
    this.hasBillItems = false;
    this.accidentTravailCount = 0;
    this.documentCount = 0;
    this.accordCollectif = null;
    this.hasPermanents = false;
    this.suggestedSubscriptionTypeId = 0;
    this.commercialId = 0;
    this.userId = 0;
    this.userDisabled = false;
    this.modeFacture = EtablissementModeFactures.NONE;
    this.creditLimit = 0;
    this.creditLimitUntil = null;
    this.metaValues = [];
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Etablissement): Etablissement {
    const newEtablissement: Etablissement = new Etablissement();
    newEtablissement.id = obj.id;
    newEtablissement.isDomtom = obj.isDomtom;
    newEtablissement.societeId = obj.societeId;
    newEtablissement.alias = obj.alias;
    newEtablissement.nom = obj.nom;
    newEtablissement.siret = obj.siret;
    newEtablissement.verifySiret = obj.verifySiret;
    newEtablissement.siretValid = obj.siretValid;
    newEtablissement.valid = obj.valid;
    newEtablissement.brancheId = obj.brancheId;
    newEtablissement.brancheCode = obj.brancheCode;
    newEtablissement.brancheNom = obj.brancheNom;
    newEtablissement.brancheInsee = obj.brancheInsee;
    newEtablissement.conventionId = obj.conventionId;
    newEtablissement.t3252 = obj.t3252;
    newEtablissement.t1790 = obj.t1790;
    newEtablissement.conventionCode = obj.conventionCode;
    newEtablissement.conventionNom = obj.conventionNom;
    newEtablissement.conventionInsee = obj.conventionInsee;
    newEtablissement.siege = obj.siege;
    newEtablissement.trancheEffectifId = obj.trancheEffectifId;
    newEtablissement.trancheEffectifLabel = obj.trancheEffectifLabel;
    newEtablissement.soumisTva = obj.soumisTva;
    newEtablissement.formeJuridiqueId = obj.formeJuridiqueId;
    newEtablissement.formeJuridiqueLabel = obj.formeJuridiqueLabel;
    newEtablissement.formeJuridiqueInsee = obj.formeJuridiqueInsee;
    newEtablissement.identAssociation = obj.identAssociation;
    newEtablissement.dateCreation = new Date(obj.dateCreation);
    newEtablissement.dateFermeture = obj.dateFermeture ? new Date(obj.dateFermeture) : null;
    newEtablissement.managed = obj.managed;
    newEtablissement.representantId = obj.representantId;
    newEtablissement.representantLegal = obj.representantLegal;
    newEtablissement.numero = obj.numero;
    newEtablissement.mail = obj.mail;
    newEtablissement.adresseId = obj.adresseId;
    newEtablissement.ville = obj.ville;
    newEtablissement.adresseLigne1 = obj.adresseLigne1;
    newEtablissement.codePostal = obj.codePostal;
    newEtablissement.urssafId = obj.urssafId;
    newEtablissement.urssaf = obj.urssaf;
    newEtablissement.congesSpec = obj.congesSpec;
    newEtablissement.audiens = obj.audiens;
    newEtablissement.poleEmploiStatut = obj.poleEmploiStatut;
    newEtablissement.cadreEmbaucheId = obj.cadreEmbaucheId;
    newEtablissement.poleEmploiAffiliation = obj.poleEmploiAffiliation;
    newEtablissement.poleEmploiAdhesion = obj.poleEmploiAdhesion;
    newEtablissement.poleEmploiIdentifiant = obj.poleEmploiIdentifiant;
    newEtablissement.fnas = obj.fnas;
    newEtablissement.fcap = obj.fcap;
    newEtablissement.retraiteComplementaireId = obj.retraiteComplementaireId;
    newEtablissement.retraiteComplementaireNom = obj.retraiteComplementaireNom;
    newEtablissement.licenceStatus = obj.licenceStatus;
    newEtablissement.licenceRecepisse = obj.licenceRecepisse;
    newEtablissement.licenceSpectacle = obj.licenceSpectacle;
    newEtablissement.licenceValidite = obj.licenceValidite ? new Date(obj.licenceValidite) : null;
    newEtablissement.statutLicenceSpectacle = obj.statutLicenceSpectacle;
    newEtablissement.IdCi98 = obj.IdCi98;
    newEtablissement.fractionDsn = JSON.parse(JSON.stringify(obj.fractionDsn));
    newEtablissement.exoPeriodes = JSON.parse(JSON.stringify(obj.exoPeriodes));
    newEtablissement.logo = obj.logo;
    newEtablissement.subscriptionId = obj.subscriptionId;
    newEtablissement.prelevRibId = obj.prelevRibId;
    newEtablissement.prelevRib = obj.prelevRib;
    newEtablissement.salaireMeansId = obj.salaireMeansId;
    newEtablissement.salaireRib = obj.salaireRib;
    newEtablissement.paymentAutoSalaire = obj.paymentAutoSalaire;
    newEtablissement.hasCartItems = obj.hasCartItems;
    newEtablissement.hasBillItems = obj.hasBillItems;
    newEtablissement.accidentTravailCount = obj.accidentTravailCount;
    newEtablissement.documentCount = obj.documentCount;
    newEtablissement.accordCollectif = obj.accordCollectif;
    newEtablissement.hasPermanents = obj.hasPermanents;
    newEtablissement.suggestedSubscriptionTypeId = obj.suggestedSubscriptionTypeId;
    newEtablissement.commercialId = obj.commercialId;
    newEtablissement.userId = obj.userId;
    newEtablissement.userDisabled = obj.userDisabled;
    newEtablissement.modeFacture = obj.modeFacture;
    newEtablissement.creditLimit = obj.creditLimit;
    newEtablissement.creditLimitUntil = obj.creditLimitUntil ? new Date(obj.creditLimitUntil) : null;
    newEtablissement.metaValues = JSON.parse(JSON.stringify(obj.metaValues));
    newEtablissement.createId = obj.createId;
    newEtablissement.failed = obj.failed;
    newEtablissement.canUpdate = obj.canUpdate;
    newEtablissement.canDelete = obj.canDelete;
    newEtablissement.display = obj.display;
    newEtablissement.clientId = obj.clientId;
    newEtablissement.notifDefType = obj.notifDefType;
    return newEtablissement;
  }

  public toJsonEtablissement (): string {
    const json = {
      isDomtom: this.isDomtom,
      societeId: this.societeId,
      alias: this.alias,
      nom: this.nom,
      siret: this.siret,
      verifySiret: this.verifySiret,
      siretValid: this.siretValid,
      valid: this.valid,
      brancheId: this.brancheId,
      brancheCode: this.brancheCode,
      brancheNom: this.brancheNom,
      brancheInsee: this.brancheInsee,
      conventionId: this.conventionId,
      t3252: this.t3252,
      t1790: this.t1790,
      conventionCode: this.conventionCode,
      conventionNom: this.conventionNom,
      conventionInsee: this.conventionInsee,
      siege: this.siege,
      trancheEffectifId: this.trancheEffectifId,
      trancheEffectifLabel: this.trancheEffectifLabel,
      soumisTva: this.soumisTva,
      formeJuridiqueId: this.formeJuridiqueId,
      formeJuridiqueLabel: this.formeJuridiqueLabel,
      formeJuridiqueInsee: this.formeJuridiqueInsee,
      identAssociation: this.identAssociation,
      dateCreation: this.dateCreation ? new Date (this.dateCreation).toString() : this.dateCreation,
      dateFermeture: this.dateFermeture ? new Date (this.dateFermeture).toString() : this.dateFermeture,
      managed: this.managed,
      representantId: this.representantId,
      representantLegal: this.representantLegal,
      numero: this.numero,
      mail: this.mail,
      adresseId: this.adresseId,
      ville: this.ville,
      adresseLigne1: this.adresseLigne1,
      codePostal: this.codePostal,
      urssafId: this.urssafId,
      urssaf: this.urssaf,
      congesSpec: this.congesSpec,
      audiens: this.audiens,
      poleEmploiStatut: this.poleEmploiStatut,
      cadreEmbaucheId: this.cadreEmbaucheId,
      poleEmploiAffiliation: this.poleEmploiAffiliation,
      poleEmploiAdhesion: this.poleEmploiAdhesion,
      poleEmploiIdentifiant: this.poleEmploiIdentifiant,
      fnas: this.fnas,
      fcap: this.fcap,
      retraiteComplementaireId: this.retraiteComplementaireId,
      retraiteComplementaireNom: this.retraiteComplementaireNom,
      licenceStatus: this.licenceStatus,
      licenceRecepisse: this.licenceRecepisse,
      licenceSpectacle: this.licenceSpectacle,
      licenceValidite: this.licenceValidite ? new Date (this.licenceValidite).toString() : this.licenceValidite,
      statutLicenceSpectacle: this.statutLicenceSpectacle,
      IdCi98: this.IdCi98,
      fractionDsn: this.fractionDsn,
      exoPeriodes: this.exoPeriodes,
      logo: this.logo,
      subscriptionId: this.subscriptionId,
      prelevRibId: this.prelevRibId,
      prelevRib: this.prelevRib,
      salaireMeansId: this.salaireMeansId,
      salaireRib: this.salaireRib,
      paymentAutoSalaire: this.paymentAutoSalaire,
      hasCartItems: this.hasCartItems,
      hasBillItems: this.hasBillItems,
      accidentTravailCount: this.accidentTravailCount,
      documentCount: this.documentCount,
      accordCollectif: this.accordCollectif,
      hasPermanents: this.hasPermanents,
      suggestedSubscriptionTypeId: this.suggestedSubscriptionTypeId,
      commercialId: this.commercialId,
      userId: this.userId,
      userDisabled: this.userDisabled,
      modeFacture: this.modeFacture,
      creditLimit: this.creditLimit,
      creditLimitUntil: this.creditLimitUntil ? new Date (this.creditLimitUntil).toString() : this.creditLimitUntil,
      metaValues: this.metaValues,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromEtablissement (obj: Etablissement): void {
    this.id = obj.id;
    this.isDomtom = obj.isDomtom;
    this.societeId = obj.societeId;
    this.alias = obj.alias;
    this.nom = obj.nom;
    this.siret = obj.siret;
    this.verifySiret = obj.verifySiret;
    this.siretValid = obj.siretValid;
    this.valid = obj.valid;
    this.brancheId = obj.brancheId;
    this.brancheCode = obj.brancheCode;
    this.brancheNom = obj.brancheNom;
    this.brancheInsee = obj.brancheInsee;
    this.conventionId = obj.conventionId;
    this.t3252 = obj.t3252;
    this.t1790 = obj.t1790;
    this.conventionCode = obj.conventionCode;
    this.conventionNom = obj.conventionNom;
    this.conventionInsee = obj.conventionInsee;
    this.siege = obj.siege;
    this.trancheEffectifId = obj.trancheEffectifId;
    this.trancheEffectifLabel = obj.trancheEffectifLabel;
    this.soumisTva = obj.soumisTva;
    this.formeJuridiqueId = obj.formeJuridiqueId;
    this.formeJuridiqueLabel = obj.formeJuridiqueLabel;
    this.formeJuridiqueInsee = obj.formeJuridiqueInsee;
    this.identAssociation = obj.identAssociation;
    this.dateCreation = new Date(obj.dateCreation);
    this.dateFermeture = obj.dateFermeture;
    this.managed = obj.managed;
    this.representantId = obj.representantId;
    this.representantLegal = obj.representantLegal;
    this.numero = obj.numero;
    this.mail = obj.mail;
    this.adresseId = obj.adresseId;
    this.ville = obj.ville;
    this.adresseLigne1 = obj.adresseLigne1;
    this.codePostal = obj.codePostal;
    this.urssafId = obj.urssafId;
    this.urssaf = obj.urssaf;
    this.congesSpec = obj.congesSpec;
    this.audiens = obj.audiens;
    this.poleEmploiStatut = obj.poleEmploiStatut;
    this.cadreEmbaucheId = obj.cadreEmbaucheId;
    this.poleEmploiAffiliation = obj.poleEmploiAffiliation;
    this.poleEmploiAdhesion = obj.poleEmploiAdhesion;
    this.poleEmploiIdentifiant = obj.poleEmploiIdentifiant;
    this.fnas = obj.fnas;
    this.fcap = obj.fcap;
    this.retraiteComplementaireId = obj.retraiteComplementaireId;
    this.retraiteComplementaireNom = obj.retraiteComplementaireNom;
    this.licenceStatus = obj.licenceStatus;
    this.licenceRecepisse = obj.licenceRecepisse;
    this.licenceSpectacle = obj.licenceSpectacle;
    this.licenceValidite = obj.licenceValidite;
    this.statutLicenceSpectacle = obj.statutLicenceSpectacle;
    this.IdCi98 = obj.IdCi98;
    this.fractionDsn = obj.fractionDsn;
    this.exoPeriodes = obj.exoPeriodes;
    this.logo = obj.logo;
    this.subscriptionId = obj.subscriptionId;
    this.prelevRibId = obj.prelevRibId;
    this.prelevRib = obj.prelevRib;
    this.salaireMeansId = obj.salaireMeansId;
    this.salaireRib = obj.salaireRib;
    this.paymentAutoSalaire = obj.paymentAutoSalaire;
    this.hasCartItems = obj.hasCartItems;
    this.hasBillItems = obj.hasBillItems;
    this.accidentTravailCount = obj.accidentTravailCount;
    this.documentCount = obj.documentCount;
    this.accordCollectif = obj.accordCollectif;
    this.hasPermanents = obj.hasPermanents;
    this.suggestedSubscriptionTypeId = obj.suggestedSubscriptionTypeId;
    this.commercialId = obj.commercialId;
    this.userId = obj.userId;
    this.userDisabled = obj.userDisabled;
    this.modeFacture = obj.modeFacture;
    this.creditLimit = obj.creditLimit;
    this.creditLimitUntil = obj.creditLimitUntil;
    this.metaValues = obj.metaValues;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareEtablissement (value: Etablissement): boolean {
    return (this.toJsonEtablissement() == value.toJsonEtablissement());
  }

  public cloneEtablissement (): Etablissement {
    return Etablissement.fromJson(this);
  }

  public createForStoreEtablissement (): Promise<Etablissement> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/etablissements/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromEtablissement(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreEtablissement (): Promise<Etablissement> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/etablissements/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromEtablissement(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreEtablissement (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/etablissements/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/etablissements/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static setFractionDsn (etablissement: Etablissement): Promise<Etablissement> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/etablissements/setFractionDsn', etablissement, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Etablissement.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static affiliationFt (etablissement: Etablissement): Promise<Etablissement> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/etablissements/affiliationFt', etablissement, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Etablissement.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static saveFractionDsn (fractionDsn: FractionDsn): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/etablissements/saveFractionDsn', fractionDsn, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static deleteFractionDsn (fractionDsn: FractionDsn): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/etablissements/deleteFractionDsn', fractionDsn, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static listClient (filter: ListFilter): Promise<Etablissement[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/etablissements/listClient', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Etablissement[] = [];
              res.data.forEach(( a: Etablissement ) => {
                cData.push(Etablissement.fromJson(a));
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Etablissements/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Etablissement.fromJson(listData.reccords[0] as Etablissement);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Etablissement> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Etablissements/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Etablissement.fromJson(listData.reccords[0] as Etablissement);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(etablissements: Etablissement[]) {
    etablissements.forEach((item) => {
      item.dateCreation = item.dateCreation ? new Date(item.dateCreation) : item.dateCreation;
      item.dateFermeture = item.dateFermeture ? new Date(item.dateFermeture) : item.dateFermeture;
      item.licenceValidite = item.licenceValidite ? new Date(item.licenceValidite) : item.licenceValidite;
      item.creditLimitUntil = item.creditLimitUntil ? new Date(item.creditLimitUntil) : item.creditLimitUntil;
    })
  }
}
